import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllBidReceived,
  getGetListConnectOpen,
  getGetListConnectSelected,
  getGetListCurrent,
} from "../../Services/ApiCalling/Listing";

// Async thunk for fetching listings
export const fetchListings = createAsyncThunk(
  "listings/fetchListings",
  async ({ token, user }) => {
    try {
      let data = await getGetListCurrent(token, user);
      return { user: data };
    } catch (err) {}
  }
);

export const activeListId = createAsyncThunk(
  "listings/activeId",
  async ({ id, user }) => {
    try {
      return { id, user };
    } catch (err) {}
  }
);

export const fetchListingConnection = createAsyncThunk(
  "listings/fetchListingConnection",
  async ({ token, user, id }) => {
    try {
      let data = await getGetListConnectOpen(token, user, id);
      return { user: data };
    } catch (err) {}
  }
);
export const fetchListingConnectionSelected = createAsyncThunk(
  "listings/fetchListingConnection_select",
  async ({ token, user, id, payload }) => {
    try {
      let data = await getGetListConnectSelected(token, user, id, payload);
      return { user: data };
    } catch (err) {}
  }
);

export const bidReceived = createAsyncThunk(
  "listings/bidReceived",
  async ({ token, user, id }) => {
    try {
      let data = await getAllBidReceived(token, user, id);
      return { user: data };
    } catch (err) {}
  }
);

const listSlice = createSlice({
  name: "listings",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListings.pending, (state) => {})
      .addCase(fetchListings.fulfilled, (state, action) => {
        state.data = action.payload?.user?.data?.data;
      })
      .addCase(fetchListings.rejected, (state, action) => {});
    builder
      .addCase(fetchListingConnection.pending, (state) => {})
      .addCase(fetchListingConnection.fulfilled, (state, action) => {
        state.connectData = action.payload?.user?.data?.data?.page;
      })
      .addCase(fetchListingConnection.rejected, (state, action) => {});
    builder
      .addCase(fetchListingConnectionSelected.pending, (state) => {})
      .addCase(fetchListingConnectionSelected.fulfilled, (state, action) => {
        state.connectData = action.payload?.user?.data?.data?.page;
      })
      .addCase(fetchListingConnectionSelected.rejected, (state, action) => {});
    builder
      .addCase(bidReceived.pending, (state) => {})
      .addCase(bidReceived.fulfilled, (state, action) => {
        state.bidList = action.payload?.user?.data?.data;
      })
      .addCase(bidReceived.rejected, (state, action) => {});
    builder
      .addCase(activeListId.pending, (state) => {})
      .addCase(activeListId.fulfilled, (state, action) => {
        state.connectActiveListId = action.payload?.id;
        state.connectSerarchUser = action.payload?.user;
      })
      .addCase(activeListId.rejected, (state, action) => {});
  },
});

export default listSlice.reducer;
